/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  IdentityProviderConnectionApplication,
  IdentityProviderConnectionApplication$inboundSchema,
} from "./identityproviderconnectionapplication.js";
import {
  IdentityProviderConnectionApplicationsSync,
  IdentityProviderConnectionApplicationsSync$inboundSchema,
} from "./identityproviderconnectionapplicationssync.js";
import {
  IdentityProviderConnectionReconcileRun,
  IdentityProviderConnectionReconcileRun$inboundSchema,
} from "./identityproviderconnectionreconcilerun.js";

export type ListIdentityProviderConnectionApplicationsResult = {
  /**
   * Applications ordered by label, live rows first. Capped at 2000 rows, the same cap a run applies.
   */
  applications: Array<IdentityProviderConnectionApplication>;
  /**
   * One applications snapshot run and the changes it applied.
   */
  lastRun?: IdentityProviderConnectionReconcileRun | undefined;
  /**
   * Watermarks of the scheduled applications snapshot. The snapshot is reconciled on a fixed platform-wide schedule.
   */
  sync: IdentityProviderConnectionApplicationsSync;
};

/** @internal */
export const ListIdentityProviderConnectionApplicationsResult$inboundSchema:
  z.ZodMiniType<ListIdentityProviderConnectionApplicationsResult, unknown> = z
    .pipe(
      z.object({
        applications: z.array(
          IdentityProviderConnectionApplication$inboundSchema,
        ),
        last_run: z.optional(
          IdentityProviderConnectionReconcileRun$inboundSchema,
        ),
        sync: IdentityProviderConnectionApplicationsSync$inboundSchema,
      }),
      z.transform((v) => {
        return remap$(v, {
          "last_run": "lastRun",
        });
      }),
    );

export function listIdentityProviderConnectionApplicationsResultFromJSON(
  jsonString: string,
): SafeParseResult<
  ListIdentityProviderConnectionApplicationsResult,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ListIdentityProviderConnectionApplicationsResult$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'ListIdentityProviderConnectionApplicationsResult' from JSON`,
  );
}
